export const checkHistoryBenefits = [
    {
        id: "save",
        title: "Экономьте время и деньги",
        text: "Мы проведём полную проверку автомобиля и предоставим детальный отчёт. Это позволит вам быстро принять решение — стоит ли связываться с продавцом и ехать на осмотр."
    },
    {
        id: "reveal",
        title: "Узнайте всё, что скрывают",
        text: "Выявим скрученный пробег, аварии и манипуляции.  С нашим отчётом вы покупаете не вслепую, а с полным пониманием реального состояния машины."
    },
    {
        id: "economy",
        title: "Знание — ваша экономия",
        text: "Полная история авто даёт вам преимущество в переговорах.  Используйте эти данные, чтобы обоснованно снизить цену и купить авто по его реальной стоимости."
    }
];